import React from "react";
import { Navigation, Link } from "react-router";
import { ZOOM_ICON } from "js/config.jsx";
import UserHandler from "js/utilities/user-handler";
import { getQueryString } from "js/utilities/get-query-string";
import Amplitude from "js/utilities/amplitude";
import TimerMixin from "react-timer-mixin";
import Spinner from "../elements/spinner";
import * as config from "../../config";
import LogErrrorsToZoomCloud from "js/utilities/log-errors-to-zc"

export default React.createClass({

  mixins: [Navigation, TimerMixin],

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  statics: {
    includeHeaderFooter: false
  },

  getInitialState: function() {

    var tokenId = "?authToken=";

    return {
      loading: true,
      error: null,
      authToken : getQueryString(tokenId),
      errorLink: false,
      handleLoginRecall : "0"
    };
  },

  componentDidMount() {
    if (this.state.authToken) {
      this.handleLogin()
    }
    else {
      // LOGGLY: user guid and state
      this.setState({error: "Error loading authToken. Please try again."});
    }
  },

  render: function () {

    var innerContent = "";
    if (this.state.loading){
      innerContent  = <Spinner className="padding-vert-30 clearfix" />;
    } else {
      innerContent = <div className="login-button"><Link to="/signin">sign in</Link></div>;
    }

    return (
      <div className="bg">
        <div className="signin">
          <div className="box">
            <div className="header">
              <img src={ZOOM_ICON} className="img" />
              <p className="title">developer account</p>
            </div>
            <br/>
            {this.state.errorLink ? <Link className="move login-text" to="/signin">{this.state.error}</Link>:<p className="login-text">{this.state.error}</p> }
          </div>
        </div>
      </div>
    )
  },

  handleLogin: function() {

    // Log out if currently logged in first...but...delete the api key first??
    if (UserHandler.loggedIn()){
      UserHandler.logout();
    }


    // Instantiate Loggly
    _LTracker.push({
      "logglyKey": "98508576-85af-467e-8713-9ae93891800c",
      "tag" : "sdksite_debug_logs",
      "sendConsoleErrors": true
    });

    UserHandler.logToLogglySimple("enroll.jsx - handleLogin - start");
    this.setState({error: "Authenticating account..."});

    var method = "POST";
    var fullURL = config.API_PREFIX + "user/tokens";

    // get user from authtoken
    // Get user from authtoken
    var reqBody = {
      authToken: this.state.authToken
    };

    var requestStartTime = Date.now();
    var request = new XMLHttpRequest();
    request.open(method, fullURL, true);
    request.setRequestHeader("Content-Type", "application/json");
    request.setRequestHeader("Accept", "application/json");

    var reqHeaders = {
      "Content-Type": "application/json",
      "Accept": "application/json",
    };

    var localContextThis = this;

    request.onerror = function() {
      UserHandler.logToLogglySimple("enroll.jsx - handleLogin - onerror 1 - fatal - 1501");
      var apiCallTimeEndToEnd = Date.now() - requestStartTime;

      UserHandler.logToLogglyWithAPIResponse(
        "enroll.jsx - handleLogin - onerror 2 - fatal - 1501",
        method,
        fullURL,
        reqHeaders,
        reqBody,
        "No responseText when errored.",
        apiCallTimeEndToEnd
      );

      var logs = {
        "status": 999,
        "method": method,
        "ok": false,
        "url": fullURL,
        "reqBody": reqBody,
        "reqHeaders": reqHeaders,
        "originalError": request.statusText,
        "filename": "enroll.jsx"
      };
      LogErrrorsToZoomCloud.sendLogs(logs, reqBody, reqHeaders);

      UserHandler.setErrorMessage("There was an error (1501) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
      localContextThis.context.router.push("/signin");
      return;
    };

    request.onload = function() {
      UserHandler.logToLogglySimple("enroll.jsx - handleLogin - onload 1");
      var apiCallTimeEndToEnd = Date.now() - requestStartTime;

      UserHandler.logToLogglyWithAPIResponse(
        "enroll.jsx - handleLogin - onload 2",
        method,
        fullURL,
        reqHeaders,
        reqBody,
        request.responseText,
        apiCallTimeEndToEnd
      );

      //
      // Check response for non-happy-path flags
      //
      var responseJSON;
      try {
        responseJSON = JSON.parse(request.responseText);
      }
      catch (e) {
        UserHandler.logToLogglySimple("enroll.jsx - handleLogin - onload - JSON.parse error - fatal - 1502 - error: " + e);
        var logs = {
          "status": 999,
          "method": method,
          "ok": false,
          "url": fullURL,
          "reqBody": reqBody,
          "reqHeaders": reqHeaders,
          "originalError": request.statusText,
          "filename": "enroll.jsx"
        };
        LogErrrorsToZoomCloud.sendLogs(logs, reqBody, reqHeaders);
        UserHandler.setErrorMessage("There was an error (1502) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
        localContextThis.context.router.push("/signin");
        return;
      }

      if(!responseJSON.meta || !responseJSON.meta.ok) {
        //
        // Check to see if ok exists but is false.  also check to make sure there is a message.
        // this is the case of "expected error"
        // we should show what this is to the user since it could be
        // CASE 1 -- something like their auth token has already been used (common)
        // CASE 2 -- badAuthToken -- this means the auth token expired
        //
        if(responseJSON.meta.ok === false && responseJSON.meta.subCode && responseJSON.meta.subCode == "authTokenAlreadyUsed") {
          UserHandler.logToLogglySimple("enroll.jsx - handleLogin - onload - authTokenAlreadyUsed 1503");
          if(responseJSON.meta.message) {
            UserHandler.setResendEmail(responseJSON.meta.message)
          }
          UserHandler.setErrorMessage("authTokenAlreadyUsed");
          localContextThis.context.router.push("/signin");
          return;
        }
        else if(responseJSON.meta.ok === false && responseJSON.meta.subCode && responseJSON.meta.subCode == "badAuthToken") {
          UserHandler.logToLogglySimple("enroll.jsx - handleLogin - onload - badAuthToken - fatal - 1550 - authtoken: " + localContextThis.state.authToken);
          UserHandler.setErrorMessage(responseJSON.meta.message);
          localContextThis.context.router.push("/signin");
          return;
        }
        else {
          UserHandler.logToLogglySimple("enroll.jsx - handleLogin - onload - malformed response meta - fatal - 1505 - request.responseText: " + request.responseText);
          UserHandler.setErrorMessage("There was an error (1505) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
          localContextThis.context.router.push("/signin");
          return;
        }
      }

      // missing/malformed data in response
      if(!responseJSON || !responseJSON.data || !responseJSON.data.user) {
        UserHandler.logToLogglySimple("enroll.jsx - handleLogin - onload - response/data/user missing - fatal - 1504");
        UserHandler.setErrorMessage("There was an error (1504) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
        localContextThis.context.router.push("/signin");
        return;
      }

      //
      // happy path for login
      //
      UserHandler.setUser(responseJSON.data.user);

      if(responseJSON.data.user && responseJSON.data.user.acceptedTermsandConditions && responseJSON.data.user.acceptedTermsandConditions == true) {
        UserHandler.setToken(responseJSON.data.token);
        localContextThis.context.router.push("/docs");
      }
      else {
        // redirect user to complete signup process (accept T&C)
        localStorage.setItem("zoom_sdk_temp_token", responseJSON.data.token);
        UserHandler.clearAuth();
        localContextThis.context.router.push("/complete-signup");
      }
    };

    request.send(JSON.stringify(reqBody));
    UserHandler.logToLogglySimple("enroll.jsx - handleLogin - sent");
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/enroll.jsx